import AnnouncementReducers from "./announcement/reducer";
import AccountReducers from "./systemConfiguration/reducer";
import SearchPriorities from "./searchPriorities/reducer";

export default {
  ...AnnouncementReducers,
  ...AccountReducers,
  ...SearchPriorities
};
